import classNames from 'clsx';
import React from 'react';

import styles from './FlipCard.scss';

interface Props {
  flipped: boolean;
  children: JSX.Element[];
}

const FlipCard: React.FC<Props> = ({ flipped, children }) => {
  const [front, back] = children;
  return (
    <>
      {front && !back && front}
      {front && back && (
        <div className={classNames(styles.flipContainer, { [styles.flipped]: flipped })}>
          <div className={styles.flipper}>
            <div className={styles.front}>{front}</div>
            <div className={styles.back}>{back}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default FlipCard;
